import React from 'react';
//@observer
export class AbfragerRight extends React.PureComponent {
    render() {
        const { app, children } = this.props;
        return (React.createElement("div", { className: "AbfragerRight", style: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', justifyContent: 'flex-end' } },
            children,
            React.createElement("div", { id: "schlaukopf.de_ad_1", className: "hideBelow1000Width", style: { marginBottom: 5, marginTop: 20, marginRight: 5 } }),
            React.createElement("div", { id: "schlaukopf.de_ad_2", className: "hideBelow1000Width", style: { marginBottom: 5, marginRight: 5 } }),
            React.createElement("div", { id: "schlaukopf.de_ad_3", className: "hideBelow1000Width", style: { marginRight: 5, marginBottom: 5 } })));
    }
}
